/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DigitizingserviceMelcoDigitizingModelsTranslatedString,
    DigitizingserviceMelcoDigitizingModelsTranslatedStringFromJSON,
    DigitizingserviceMelcoDigitizingModelsTranslatedStringFromJSONTyped,
    DigitizingserviceMelcoDigitizingModelsTranslatedStringToJSON,
} from './';

/**
 * 
 * @export
 * @interface DigitizingserviceMelcoDigitizingModelsTranslateResponse
 */
export interface DigitizingserviceMelcoDigitizingModelsTranslateResponse {
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsTranslateResponse
     */
    text?: string | null;
    /**
     * 
     * @type {Array<DigitizingserviceMelcoDigitizingModelsTranslatedString>}
     * @memberof DigitizingserviceMelcoDigitizingModelsTranslateResponse
     */
    strings?: Array<DigitizingserviceMelcoDigitizingModelsTranslatedString> | null;
}

export function DigitizingserviceMelcoDigitizingModelsTranslateResponseFromJSON(json: any): DigitizingserviceMelcoDigitizingModelsTranslateResponse {
    return DigitizingserviceMelcoDigitizingModelsTranslateResponseFromJSONTyped(json, false);
}

export function DigitizingserviceMelcoDigitizingModelsTranslateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingserviceMelcoDigitizingModelsTranslateResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'text': !exists(json, 'text') ? undefined : json['text'],
        'strings': !exists(json, 'strings') ? undefined : (json['strings'] === null ? null : (json['strings'] as Array<any>).map(DigitizingserviceMelcoDigitizingModelsTranslatedStringFromJSON)),
    };
}

export function DigitizingserviceMelcoDigitizingModelsTranslateResponseToJSON(value?: DigitizingserviceMelcoDigitizingModelsTranslateResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'text': value.text,
        'strings': value.strings === undefined ? undefined : (value.strings === null ? null : (value.strings as Array<any>).map(DigitizingserviceMelcoDigitizingModelsTranslatedStringToJSON)),
    };
}


